import React from "react"

const Loading = () => {
  return (
    <div className="w-100 d-flex justify-content-center">
      <div className="loadingio-spinner-pulse-glztcbqacc5">
        <div className="ldio-j2h53orr6f9">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

export default Loading
